module.exports = __webpack_public_path__ + "static/media/EHS-Risk-Assessment-Policy.0503d75c.pdf";